import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { FilterSidebarLayoutContent } from '../../../components/layout';
import { exportFiltersSchema } from './types';
import { ExportFilterFields } from './ExportFilterFields';
import { ExportsTable } from './ExportsTable/ExportsTable';
import { useDefaultFilterValues } from './useDefaultFilterValues';
import { useReportTypes } from './useReportTypes';

interface SidebarToggleProps {
    showSidebar: boolean;
    toggleSidebar: () => void;
}
export const ExportFiterPage = ({ ...other }: SidebarToggleProps) => {
    const { data: legacyReportTypes, isLoading: reportTypesLoading } = useReportTypes();

    const defaultValues = useDefaultFilterValues();

    return (
        <FilterSidebarLayoutContent
            loading={reportTypesLoading}
            {...other}
            filterSchema={exportFiltersSchema}
            submitButtonLabel={lt(TextKey.Filter)}
            defaultFilterValues={defaultValues}
            filterSidebar={{
                title: lt(TextKey.Filter),
                fields: <ExportFilterFields reportTypes={legacyReportTypes?.reportTypes ?? []} />,
            }}
        >
            {({ filterValues }) => <ExportsTable filters={filterValues} />}
        </FilterSidebarLayoutContent>
    );
};
